(function () {
    'use strict';

    run.pages.register = function() {
        const terms_link = document.getElementById('open_terms');
        const terms = document.getElementById('privacy_policy').innerHTML;
        terms_link.addEventListener('click', function(e) {
            Swal.fire({
                title: null,
                html: terms,
                showCloseButton: false,
                showCancelButton: true,
                showConfirmButton: false,
                focusCancel: true,
                cancelButtonText: translations.confirmAlerts.close,
                buttonsStyling: false,
                reverseButtons: true,
                customClass: {
                    cancelButton: 'btn btn-lg btn-secondary',
                },
                showClass: {
                    popup: 'animate__animated animated__fast animate__fadeInUp'
                },
                hideClass: {
                    popup: 'animate__animated animated__fast animate__fadeOutDown'
                }
            }).then((result) => {
                if (result.value) {
                    window.location.href = _location;
                }
            });
        });

        const formRegister = document.getElementById('register');
        formRegister.addEventListener('submit', (e) => {
            const checkbox = document.getElementById('terms');
            if (checkbox.checked === false) {
                e.preventDefault();
                Swal.fire(translations.register.acceptTerms);
                return false;
            }
        });
    };
})();